// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file team.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { UserRole, UserRoleJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { ListFilter, ListFilterJson, ListInfo, ListInfoJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { User, UserJson } from "./user_pb";
import { file_user } from "./user_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file team.proto.
 */
export const file_team: GenFile = /*@__PURE__*/
  fileDesc("Cgp0ZWFtLnByb3RvEglyYWNjb29uYWkioQIKBFRlYW0SCgoCaWQYASACKAQSDAoEbmFtZRgCIAIoCRIxCgl1c2VyX3JvbGUYAyACKA4yEy5yYWNjb29uYWkuVXNlclJvbGVSCXVzZXJfcm9sZRI0ChVvd25lcl9vcmdhbml6YXRpb25faWQYBCACKARSFW93bmVyX29yZ2FuaXphdGlvbl9pZBIeCgV1c2VycxgFIAMoCzIPLnJhY2Nvb25haS5Vc2VyEjoKCmNyZWF0ZWRfYXQYZSACKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgpjcmVhdGVkX2F0EjoKCnVwZGF0ZWRfYXQYZiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wUgp1cGRhdGVkX2F0Ip8BCgpUZWFtQ3JlYXRlEgwKBG5hbWUYASACKAkSMQoJdXNlcl9yb2xlGAIgAigOMhMucmFjY29vbmFpLlVzZXJSb2xlUgl1c2VyX3JvbGUSNAoVb3duZXJfb3JnYW5pemF0aW9uX2lkGAMgAigEUhVvd25lcl9vcmdhbml6YXRpb25faWQSGgoIdXNlcl9pZHMYBCADKARSCHVzZXJfaWRzInUKClRlYW1VcGRhdGUSCgoCaWQYASACKAQSDAoEbmFtZRgCIAEoCRIxCgl1c2VyX3JvbGUYAyABKA4yEy5yYWNjb29uYWkuVXNlclJvbGVSCXVzZXJfcm9sZRIaCgh1c2VyX2lkcxgEIAMoBFIIdXNlcl9pZHMitwEKD1RlYW1MaXN0UmVxdWVzdBI2ChZvd25lcl9vcmdhbml6YXRpb25faWRzGAEgAygEUhZvd25lcl9vcmdhbml6YXRpb25faWRzEjMKCnVzZXJfcm9sZXMYAiADKA4yEy5yYWNjb29uYWkuVXNlclJvbGVSCnVzZXJfcm9sZXMSNwoLbGlzdF9maWx0ZXIYCiABKAsyFS5yYWNjb29uYWkuTGlzdEZpbHRlclILbGlzdF9maWx0ZXIiXQoIVGVhbUxpc3QSHgoFdGVhbXMYASADKAsyDy5yYWNjb29uYWkuVGVhbRIxCglsaXN0X2luZm8YAiABKAsyEy5yYWNjb29uYWkuTGlzdEluZm9SCWxpc3RfaW5mb0IGWgQuL3Bi", [file_enums, file_general, file_google_protobuf_timestamp, file_user]);

/**
 * A named set of users of one organization. Every member must have the team's user_role.
 *
 * @generated from message raccoonai.Team
 */
export type Team = Message<"raccoonai.Team"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required string name = 2;
   */
  name: string;

  /**
   * @generated from field: required raccoonai.UserRole user_role = 3 [json_name = "user_role"];
   */
  userRole: UserRole;

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: repeated raccoonai.User users = 5;
   */
  users: User[];

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;
};

/**
 * A named set of users of one organization. Every member must have the team's user_role.
 *
 * @generated from message raccoonai.Team
 */
export type TeamJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required string name = 2;
   */
  name?: string;

  /**
   * @generated from field: required raccoonai.UserRole user_role = 3 [json_name = "user_role"];
   */
  user_role?: UserRoleJson;

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: repeated raccoonai.User users = 5;
   */
  users?: UserJson[];

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.Team.
 * Use `create(TeamSchema)` to create a new message.
 */
export const TeamSchema: GenMessage<Team, {jsonType: TeamJson}> = /*@__PURE__*/
  messageDesc(file_team, 0);

/**
 * @generated from message raccoonai.TeamCreate
 */
export type TeamCreate = Message<"raccoonai.TeamCreate"> & {
  /**
   * @generated from field: required string name = 1;
   */
  name: string;

  /**
   * @generated from field: required raccoonai.UserRole user_role = 2 [json_name = "user_role"];
   */
  userRole: UserRole;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: repeated uint64 user_ids = 4 [json_name = "user_ids"];
   */
  userIds: bigint[];
};

/**
 * @generated from message raccoonai.TeamCreate
 */
export type TeamCreateJson = {
  /**
   * @generated from field: required string name = 1;
   */
  name?: string;

  /**
   * @generated from field: required raccoonai.UserRole user_role = 2 [json_name = "user_role"];
   */
  user_role?: UserRoleJson;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: repeated uint64 user_ids = 4 [json_name = "user_ids"];
   */
  user_ids?: string[];
};

/**
 * Describes the message raccoonai.TeamCreate.
 * Use `create(TeamCreateSchema)` to create a new message.
 */
export const TeamCreateSchema: GenMessage<TeamCreate, {jsonType: TeamCreateJson}> = /*@__PURE__*/
  messageDesc(file_team, 1);

/**
 * @generated from message raccoonai.TeamUpdate
 */
export type TeamUpdate = Message<"raccoonai.TeamUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional raccoonai.UserRole user_role = 3 [json_name = "user_role"];
   */
  userRole: UserRole;

  /**
   * Replaces the whole membership; an empty list removes every member.
   *
   * @generated from field: repeated uint64 user_ids = 4 [json_name = "user_ids"];
   */
  userIds: bigint[];
};

/**
 * @generated from message raccoonai.TeamUpdate
 */
export type TeamUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional string name = 2;
   */
  name?: string;

  /**
   * @generated from field: optional raccoonai.UserRole user_role = 3 [json_name = "user_role"];
   */
  user_role?: UserRoleJson;

  /**
   * Replaces the whole membership; an empty list removes every member.
   *
   * @generated from field: repeated uint64 user_ids = 4 [json_name = "user_ids"];
   */
  user_ids?: string[];
};

/**
 * Describes the message raccoonai.TeamUpdate.
 * Use `create(TeamUpdateSchema)` to create a new message.
 */
export const TeamUpdateSchema: GenMessage<TeamUpdate, {jsonType: TeamUpdateJson}> = /*@__PURE__*/
  messageDesc(file_team, 2);

/**
 * @generated from message raccoonai.TeamListRequest
 */
export type TeamListRequest = Message<"raccoonai.TeamListRequest"> & {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];

  /**
   * @generated from field: repeated raccoonai.UserRole user_roles = 2 [json_name = "user_roles"];
   */
  userRoles: UserRole[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;
};

/**
 * @generated from message raccoonai.TeamListRequest
 */
export type TeamListRequestJson = {
  /**
   * @generated from field: repeated uint64 owner_organization_ids = 1 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];

  /**
   * @generated from field: repeated raccoonai.UserRole user_roles = 2 [json_name = "user_roles"];
   */
  user_roles?: UserRoleJson[];

  /**
   * @generated from field: optional raccoonai.ListFilter list_filter = 10 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;
};

/**
 * Describes the message raccoonai.TeamListRequest.
 * Use `create(TeamListRequestSchema)` to create a new message.
 */
export const TeamListRequestSchema: GenMessage<TeamListRequest, {jsonType: TeamListRequestJson}> = /*@__PURE__*/
  messageDesc(file_team, 3);

/**
 * @generated from message raccoonai.TeamList
 */
export type TeamList = Message<"raccoonai.TeamList"> & {
  /**
   * @generated from field: repeated raccoonai.Team teams = 1;
   */
  teams: Team[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  listInfo?: ListInfo;
};

/**
 * @generated from message raccoonai.TeamList
 */
export type TeamListJson = {
  /**
   * @generated from field: repeated raccoonai.Team teams = 1;
   */
  teams?: TeamJson[];

  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 2 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;
};

/**
 * Describes the message raccoonai.TeamList.
 * Use `create(TeamListSchema)` to create a new message.
 */
export const TeamListSchema: GenMessage<TeamList, {jsonType: TeamListJson}> = /*@__PURE__*/
  messageDesc(file_team, 4);

